
const MuiIconButton = {
  styleOverrides: {
    root: {
      '&:disabled': {
        opacity: 0.35,
      },
    },
    colorError: ({ theme }: any) => ({
      '&:disabled': {
        color: theme.palette.error.main,
      },
    }),
    colorSuccess: ({ theme }: any) => ({
      color: theme.palette.success.main,

      '&:disabled': {
        color: theme.palette.success.main,
      },
    }),
    colorWarning: ({ theme }: any) => ({
      color: theme.palette.warning.secondary,

      '&:disabled': {
        color: theme.palette.warning.secondary,
      },
    }),
  },
};

export default MuiIconButton;
